'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _is = require('./is');
var _is2 = _interopRequireDefault(_is);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_ref) {
    var value = _ref.value;
    return value ? "Sorry you cannot proceed if you've answered yes to this question" : 'Please answer this question';
  };
  return (0, _is2.default)('N', errorMessage);
};